export function getTopicsToSubscribe({ userContext }) {

  return [
    `v2018.${userContext.offering}.${userContext.langISO2}.ev.json`, // subscribe for message types: 5, 6, 22
    `v2018.${userContext.offering}.ev.json`, // subscribe for message types:  16, 17, 18, 8, 7, 11, 23, 32
    // `v2018.${userContext.offering}.bh.json` // subscribe for message types: 24
  ];
}
